import api from '@/api';

import { API_BASE_URL } from '..';
import {
  MailConfiguration,
  MailConfigurationCreateRequest,
  MailConfigurationUpdateRequest,
  MailConfigurationVerifyRequest,
  SenderType,
} from './MailConfigurationController.types';

const CONTROLLER_URL = `${API_BASE_URL}/mail-configuration`;

export async function getMailConfiguration(params: {
  senderId?: number;
  sender: SenderType;
}): Promise<MailConfiguration> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as MailConfiguration;
}

export async function mailConfigurationCreate(
  obj: MailConfigurationCreateRequest,
) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj)) as unknown;

  return result as MailConfiguration;
}

export async function mailConfigurationUpdate(
  obj: MailConfigurationUpdateRequest,
) {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as MailConfiguration;
}

export async function mailConfigurationUpdateVerify(
  obj: MailConfigurationVerifyRequest,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/verify`,
    obj,
    null,
  )) as unknown;

  return result as MailConfiguration;
}
